import angular from 'angular';
import { routes } from "./ordensintervencao.routes";
import DirectoryIntervencoesController from "./directory/directory.controller";
import DetalhesIntervencoesController from "./details/details.controller";
import CreateIntervencaoController from "./new/new.controller";
export default angular.module('app.elv.oi', [])
    .config(routes)
    .controller('DirectoryIntervencoesController', DirectoryIntervencoesController)
    .controller('DetalhesIntervencoesController', DetalhesIntervencoesController)
    .controller('CreateIntervencaoController', CreateIntervencaoController)
    .name;
